import { ThemeConfig } from './button-theme.config';

/**
 * Dark mode theme configuration for all button themes and modes.
 * All CSS classes are statically defined for Tailwind CSS 4 compatibility.
 */
export const DARK_THEME_CONFIG: ThemeConfig = {
  primary: {
    filled: {
      enabled: {
        bg: 'bg-btn-dark-primary-bg hover:bg-btn-dark-primary-bg-hover active:bg-btn-dark-primary-bg-pressed',
        text: 'text-btn-dark-primary-text',
        border: 'border-btn-dark-primary-border hover:border-btn-dark-primary-border-hover active:border-btn-dark-primary-border-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-primary-bg-pressed!',
        text: 'text-btn-dark-primary-text',
        border: 'border-btn-dark-primary-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-primary-bg-disabled',
        text: 'text-btn-dark-primary-text-disabled',
        border: 'border-btn-dark-primary-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-dark-primary-outlined-bg hover:bg-btn-dark-primary-outlined-bg-hover active:bg-btn-dark-primary-outlined-bg-pressed',
        text: 'text-btn-dark-primary-outlined-text hover:text-btn-dark-primary-outlined-text-hover active:text-btn-dark-primary-outlined-text-pressed',
        border: 'border-btn-dark-primary-outlined-border hover:border-btn-dark-primary-outlined-border-hover active:border-btn-dark-primary-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-primary-outlined-bg-pressed!',
        text: 'text-btn-dark-primary-outlined-text-pressed',
        border: 'border-btn-dark-primary-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-primary-outlined-bg-disabled',
        text: 'text-btn-dark-primary-outlined-text-disabled',
        border: 'border-btn-dark-primary-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-dark-primary-bg-hover active:bg-btn-dark-primary-bg-pressed',
        text: 'text-btn-dark-primary-flat-text hover:text-btn-dark-primary-flat-text-hover active:text-btn-dark-primary-flat-text-pressed',
        border: 'border-btn-dark-primary-border-flat hover:border-btn-dark-primary-border-flat-hover active:border-btn-dark-primary-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-primary-bg-pressed!',
        text: 'text-btn-dark-primary-flat-text-pressed',
        border: 'border-btn-dark-primary-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-dark-primary-flat-text-disabled',
        border: 'border-btn-dark-primary-border-flat-disabled',
      },
    },
  },
  secondary: {
    filled: {
      enabled: {
        bg: 'bg-btn-dark-secondary-bg hover:bg-btn-dark-secondary-bg-hover active:bg-btn-dark-secondary-bg-pressed',
        text: 'text-btn-dark-secondary-text',
        border: 'border-btn-dark-secondary-border hover:border-btn-dark-secondary-border-hover active:border-btn-dark-secondary-border-pressed',
      },
      active: {
        bg: 'bg-btn-dark-secondary-bg-pressed!',
        text: 'text-btn-dark-secondary-text',
        border: 'border-btn-dark-secondary-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-secondary-bg-disabled',
        text: 'text-btn-dark-secondary-text-disabled',
        border: 'border-btn-dark-secondary-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-dark-secondary-outlined-bg hover:bg-btn-dark-secondary-outlined-bg-hover active:bg-btn-dark-secondary-outlined-bg-pressed',
        text: 'text-btn-dark-secondary-outlined-text hover:text-btn-dark-secondary-outlined-text-hover active:text-btn-dark-secondary-outlined-text-pressed',
        border: 'border-btn-dark-secondary-outlined-border hover:border-btn-dark-secondary-outlined-border-hover active:border-btn-dark-secondary-outlined-border-pressed',
      },
      active: {
        bg: 'bg-btn-dark-secondary-outlined-bg-pressed!',
        text: 'text-btn-dark-secondary-outlined-text-pressed',
        border: 'border-btn-dark-secondary-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-secondary-outlined-bg-disabled',
        text: 'text-btn-dark-secondary-outlined-text-disabled',
        border: 'border-btn-dark-secondary-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-dark-secondary-bg-hover active:bg-btn-dark-secondary-bg-pressed',
        text: 'text-btn-dark-secondary-flat-text hover:text-btn-dark-secondary-flat-text-hover active:text-btn-dark-secondary-flat-text-pressed',
        border: 'border-btn-dark-secondary-border-flat hover:border-btn-dark-secondary-border-flat-hover active:border-btn-dark-secondary-border-flat-pressed',
      },
      active: {
        bg: 'bg-btn-dark-secondary-bg-pressed!',
        text: 'text-btn-dark-secondary-flat-text-pressed',
        border: 'border-btn-dark-secondary-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-dark-secondary-flat-text-disabled',
        border: 'border-btn-dark-secondary-border-flat-disabled',
      },
    },
  },
  danger: {
    filled: {
      enabled: {
        bg: 'bg-btn-dark-danger-bg hover:bg-btn-dark-danger-bg-hover active:bg-btn-dark-danger-bg-pressed',
        text: 'text-btn-dark-danger-text',
        border: 'border-btn-dark-danger-border hover:border-btn-dark-danger-border-hover active:border-btn-dark-danger-border-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-danger-bg-pressed!',
        text: 'text-btn-dark-danger-text',
        border: 'border-btn-dark-danger-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-danger-bg-disabled',
        text: 'text-btn-dark-danger-text-disabled',
        border: 'border-btn-dark-danger-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-dark-danger-outlined-bg hover:bg-btn-dark-danger-outlined-bg-hover active:bg-btn-dark-danger-outlined-bg-pressed',
        text: 'text-btn-dark-danger-outlined-text hover:text-btn-dark-danger-outlined-text-hover active:text-btn-dark-danger-outlined-text-pressed',
        border: 'border-btn-dark-danger-outlined-border hover:border-btn-dark-danger-outlined-border-hover active:border-btn-dark-danger-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-danger-outlined-bg-pressed!',
        text: 'text-btn-dark-danger-outlined-text-pressed',
        border: 'border-btn-dark-danger-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-dark-danger-outlined-bg-disabled',
        text: 'text-btn-dark-danger-outlined-text-disabled',
        border: 'border-btn-dark-danger-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-dark-danger-bg-hover active:bg-btn-dark-danger-bg-pressed',
        text: 'text-btn-dark-danger-flat-text hover:text-btn-dark-danger-flat-text-hover active:text-btn-dark-danger-flat-text-pressed',
        border: 'border-btn-dark-danger-border-flat hover:border-btn-dark-danger-border-flat-hover active:border-btn-dark-danger-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-dark-danger-bg-pressed!',
        text: 'text-btn-dark-danger-flat-text-pressed',
        border: 'border-btn-dark-danger-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-dark-danger-flat-text-disabled',
        border: 'border-btn-dark-danger-border-flat-disabled',
      },
    },
  },
  ai: {
    filled: {
      enabled: {
        bg: 'bg-btn-ai-bg hover:bg-btn-ai-bg-hover active:bg-btn-ai-bg-pressed',
        text: 'text-btn-ai-text hover:text-btn-ai-text active:text-btn-ai-text-pressed',
        border: 'border-btn-ai-border hover:border-btn-ai-border-hover active:border-btn-ai-border-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-bg-pressed!',
        text: 'text-btn-ai-text-pressed',
        border: 'border-btn-ai-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-ai-bg-disabled',
        text: 'text-btn-ai-text-disabled',
        border: 'border-btn-ai-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-ai-outlined-bg hover:bg-btn-ai-outlined-bg-hover active:bg-btn-ai-outlined-bg-pressed',
        text: 'text-btn-ai-outlined-text hover:text-btn-ai-outlined-text-hover active:text-btn-ai-outlined-text-pressed',
        border: 'border-btn-ai-outlined-border hover:border-btn-ai-outlined-border-hover active:border-btn-ai-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-outlined-bg-pressed!',
        text: 'text-btn-ai-outlined-text-pressed',
        border: 'border-btn-ai-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-ai-outlined-bg-disabled',
        text: 'text-btn-ai-outlined-text-disabled',
        border: 'border-btn-ai-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-ai-bg-hover active:bg-btn-ai-bg-pressed',
        text: 'text-btn-ai-flat-text hover:text-btn-ai-flat-text-hover active:text-btn-ai-flat-text-pressed',
        border: 'border-btn-ai-border-flat hover:border-btn-ai-border-flat-hover active:border-btn-ai-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-bg-pressed!',
        text: 'text-btn-ai-flat-text-pressed',
        border: 'border-btn-ai-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-ai-flat-text-disabled',
        border: 'border-btn-ai-border-flat-disabled',
      },
    },
  },
};
